import React, { useState, useMemo, useEffect, useCallback, useRef } from 'react';
import { nanoid } from 'nanoid';

import { ReactComponent as Placeholder } from 'undraw/avatar.svg';

// @name: string | input's name
// @value: string | input's value
// @error: string | error's description
// @onChange: function | onChange handler
const Avatar = ({
	name,
	value,
	error,
	onChange,
}) => {
	// Generate unique input's id
	const id = useMemo(() => nanoid(), []);

	// Create input's ref
	const input = useRef(null);

	// Cache preview's blob
	const [preview, setPreview] = useState('');

	// Create's selected file's preview
	// @file: File | selected file
	const createPreview = useCallback((file) => {
		if (typeof file === 'string' && file !== '') {
			return `${process.env.REACT_APP_CDN}/avatars/${file}`;
		} else {
			return file ? URL.createObjectURL(file) : '';
		}
	}, []);

	// Handles file input's onChange event
	// @event: object | onChange event
	const handleChange = event => {
		const { name, files } = event.target;

		// Update state's value
		onChange({ name, value: files[0] });
	};

	// Handles file input's onClick event
	const handleRemove = () => {
		// Reset input's value
		input.current.value = '';

		// Update state's value
		onChange({ name, value: '' });
	};

	// Create preview based on value
	useEffect(() => setPreview(createPreview(value)), [value, createPreview]);

	return (
		<div className="form__element">
			<div className="avatar">
				{preview ? (
					<div className="avatar__preview" onClick={handleRemove}>
						{/* Preview's image */}
						<img
							src={preview}
							alt="Avatar"
						/>
					</div>
				) : (
					<label htmlFor={id} className="avatar__placeholder">
						{/* Drawing's component as raw svg */}
						<Placeholder />
					</label>
				)}
			</div>

			{/* Hidden file upload's input */}
			<input
				id={id}
				ref={input}
				name={name}
				type="file"
				accept="image/*"
				className="avatar__input"
				onChange={handleChange}
			/>

			{/* Render error only if it has been passed */}
			{error &&<div className="form__error">{error}</div>}
		</div>
	);
};

export default Avatar;
